import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import { Box, Typography } from "@mui/material";
import { TablePaymentMethod, getImage } from "@dishopsaas/design-system";
import { showPaymentModal, showMessageModal } from "../../redux/actions";
import { TERTIARY, TEXT_VALIDATION_DELETE_CB, ERROR } from "../../constants";
import _ from "lodash";
import { deleteCB, updateCb, sortedMethods } from "../../utils/payment";
import * as styles from "./PaymentOptions.styles";
import {
  getLabel,
  accountLabels,
} from "../AccountForm/components/AccountLabel";
import { HeaderSection } from "../AccountForm/components/HeaderSection";
export default function PaymentMethods({ isMobile }) {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.userReducer);
  const { cards } = user;
  const [loading, setLoading] = useState(false);
  const [selectedCard, setSelectedCard] = useState({});

  const [selected, setSelected] = useState(
    _.find(cards, (c: any) => c.selected)?.id || ""
  );
  useEffect(() => {
    const defaultCard = _.find(cards, (c: any) => c.selected);

    if (defaultCard) {
      setSelected(defaultCard?.id);
    } else {
      setSelected("");
    }
  }, [cards]);
  return (
    <>
      <HeaderSection
        label={getLabel(accountLabels.paymentTitle, isMobile)}
        buttonName={getLabel(accountLabels.addCardButton, isMobile)}
        onClick={() => dispatch(showPaymentModal(true))}
        leftIcon="Plus"
        colorType={TERTIARY}
      />
      {_.isEmpty(cards) ? (
        <Box sx={styles.empty_option}>
          {getImage("card", { size: 80 })}
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            Aucune carte enregistrée
          </Typography>
        </Box>
      ) : (
        <Box sx={styles.bodyBox}>
          <TablePaymentMethod
            methods={sortedMethods(cards)}
            selectedId={selected}
            onSelect={(id) =>
              updateCb(id, setLoading, setSelectedCard, setSelected)
            }
            onDelete={(id) => {
              dispatch(
                showMessageModal(TEXT_VALIDATION_DELETE_CB, {
                  onClick: () => deleteCB(id),
                  showCancel: true,
                  primaryColor: ERROR,
                  text: 'Supprimer votre carte bancaire ?',
                  buttonName: "supprimer ma carte",
                  subTitle: TEXT_VALIDATION_DELETE_CB,
                  withImage: true,
                  image: "error",
                  maxWidth: 480
                })
              );
            }}
          />
        </Box>
      )}
    </>
  );
}
